import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import WhatsappButton from "./components/WhatsappButton";
import Home from "./pages/Home";
import Services from "./pages/Services";
import CruiseTours from "./pages/CruiseTours";
import CruisePortGuide from "./pages/CruisePortGuide";
import FlorencePisaLivorno from "./pages/FlorencePisaLivorno";
import LaSpeziaShoreExcursion from "./pages/LaSpeziaShoreExcursion";
import PrivateDriverTuscany from "./pages/PrivateDriverTuscany";
import PisaLeaningTower from "./pages/PisaLeaningTower";
import WineTourGuide from "./pages/WineTourGuide";
import AirportTransferGuide from "./pages/AirportTransferGuide";
import YachtTransferGuide from "./pages/YachtTransferGuide";
import FlorenceGuide from "./pages/FlorenceGuide";
import CinqueTerreGuide from "./pages/CinqueTerreGuide";
import ValdorciaGuide from "./pages/ValdorciaGuide";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import CancellationPolicy from "./pages/CancellationPolicy";
import TermsOfService from "./pages/TermsOfService";
import NotFound from "./pages/NotFound";
import LegacyRedirect from "./pages/LegacyRedirect";
import { LanguageProvider } from "./i18n/LanguageContext";
import { initLinkConversionTracking } from "./lib/gtag";

let lenisInstance = null;

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          if (lenisInstance) lenisInstance.scrollTo(el, { offset: -80 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      };
      setTimeout(scroll, 350);
    } else {
      if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    initLinkConversionTracking();
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisInstance = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenisInstance = null; };
  }, []);

  return (
    <BrowserRouter>
      <LanguageProvider>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/cruise-tours" element={<CruiseTours />} />
            <Route path="/livorno-cruise-transfers" element={<CruisePortGuide />} />
            <Route path="/florence-pisa-shore-excursion-from-livorno" element={<FlorencePisaLivorno />} />
            <Route path="/la-spezia-shore-excursion" element={<LaSpeziaShoreExcursion />} />
            <Route path="/private-driver-tuscany" element={<PrivateDriverTuscany />} />
            <Route path="/pisa-leaning-tower-tour" element={<PisaLeaningTower />} />
            <Route path="/tuscany-wine-tours" element={<WineTourGuide />} />
            <Route path="/pisa-florence-airport-transfers" element={<AirportTransferGuide />} />
            <Route path="/viareggio-carrara-yacht-transfers" element={<YachtTransferGuide />} />
            <Route path="/florence-private-tour" element={<FlorenceGuide />} />
            <Route path="/cinque-terre-private-tour" element={<CinqueTerreGuide />} />
            <Route path="/val-orcia-private-tour" element={<ValdorciaGuide />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/cancellation-policy" element={<CancellationPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/products/*" element={<LegacyRedirect />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <WhatsappButton />
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#1A1A1A", color: "#F5F5F0", border: "1px solid rgba(197,160,89,0.3)" } }} />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
